import VanToast from 'vant/lib/toast'
import '@/static/js/fs.js'
// if (this) {this.g = this}
window.g = window

g.o = console.log.bind(console)

const _u = function (i, t, e) {
  const a = Object.prototype.toString.call(i)
  return a.slice(8, -1).toLowerCase()
  // return a.replace(/\[object (\w+)\]/, "$1").toLowerCase()
}

g.u = function(i, t, e) {
  return _u(i, t, e)
}

u.i = Object.getPrototypeOf
// u.t = JSON.stringify
u.t = function (i, t, e) {
  if(i === void 0) return ''
  if(i === null) return ''
  if(['function', 'regexp'].includes(u(i))) return i.toString()
  if('string' === u(i)) return JSON.parse(i, t, e)
  // date
  return JSON.stringify(i, t, e)
}

// u.e = Object.assign
u.e = function(i, t, e) {
  return u.ne(u.en(i).filter(k => k[0] != t))
}
u.n = n => Array.from(Array(n).keys())
u.n1 = n => u.n(n + 1).slice(1)

Function.prototype.i = Function.prototype.call
Function.prototype.t = Function.prototype.bind
Function.prototype.n = function(...i){ return new this(...i) }

u.va = v => ['string', 'boolean', 'number'].includes(typeof v)

String.prototype.i = function(i, t, e) {
  if (i === void 0) return this.length
  if (typeof i == 'number') return i < 0 ? this[this.length + i] : this[i]
  if (u(i) == "regexp") return this.match(i)
  // return this.slice(0, this.indexOf(i))
  return this.includes(i)
}
String.prototype.e = function(i, t, e) {
  if (i === void 0) return this.toLowerCase()
  if (typeof i == 'number') return this.split('').e(i, t, e).join('')
  if (u(i) == 'object') {
    const en = u.en(i)
    var tmp = this
    for (var [k, v] of en) tmp = tmp.replace(new RegExp(k, 'g'), v)
    return tmp
  }
  // if (t === 1) return this.replace(i, t)
  return this.replaceAll(i, t)
}
String.prototype.t = function(i, t, e) {
  if (i === void 0) return this.trim()
  if (typeof i == 'number') return this.slice(i, t, e)
  if (t === 1) return [this.slice(0, this.indexOf(i)), this.slice(this.indexOf(i + 1))]
  return this.split(i)
}
String.prototype.n = function(i, t, e) {
  // if (i === void 0) return String.raw({ raw: this })
  if (typeof i == 'number') return this.repeat(i, t, e)
  // padStart
  if (u(i) == "regexp") return this.search(i)
  if (t === 0) return this.startsWith(i)
  if (t === -1) return this.endsWith(i)
  if (t === !0) return this.lastIndexOf(i)
  return this.indexOf(i)
}
Array.prototype.t = function(i, t, e) {
  if (i === void 0) return this.filter(Boolean)
  if (typeof i == 'number') return this.slice(i, t, e)
  if (u(i) == "array") return this.concat(i)
  if (t === 1) return this.reduce(i, t, e)
  // if (typeof i == "function" && i.length == 2) return this.reduce(i, t, e)
  if (typeof i == "function") return this.map(i, t, e)
  return this.join(i)
}
Array.prototype.n = function(i, t, e) {
  // if (i === void 0) return this.entries()
  // if (typeof i == 'number') return this.fill(i, t, e)
  if (t === 1) return this.findIndex(i, t, e)
  if (typeof i == "function") return this.filter(i, t, e)
  return this.indexOf(i)
}
Array.prototype.e = function(i, t, e) {
  if (i === void 0) return this.pop(), this
  if (typeof i == 'number') return this.splice(i, t, e), this
  // if (t === !0) return this.sort(i)
  // if (t === !1) return this.reverse()
  // if (t === 0) return this.unshift(i)
  // if (t === 1) return this.shift()
  if (typeof i == "function") return this.forEach(i, t, e), this
  return this.push(i), this
}
Array.prototype.i = function(i, t, e) {
  // if(!this.length) return this
  if (i === void 0) return this.length
  if (typeof i == 'number') return i < 0 ? this[this.length + i] : this[i]
  if (typeof i == "function") return this.reduce(i, t, e)
  return this.includes(i)
}

u.log = o
u.jn = JSON.parse
u.nj = JSON.stringify

u.set = Object.assign
u.en = Object.entries
u.ne = Object.fromEntries

function tm(i, t, e) {
  if (t === 1) return new Promise(r => setTimeout(r, i))
  if (typeof i == 'function') return setTimeout(i, t || 1000)
  if (typeof i == 'string') return new Date(i).getTime()
  const d = new Date(i || Date.now())
  return d.toJSON().t(0, 11).e('T', ' ') + d.toString().t(16, 24)
}

u.tm = tm
u.set(u.tm, {
  ms: 1,
  s: 1000, // second
  m: 1000 * 60, // minute
  h: 1000 * 60 * 60, // hour
  d: 1000 * 60 * 60 * 24 // day
})

u.mt = function(i, t, e){
  if (i === void 0) return Math.random()
  return Math.floor(i)
}
u.set(u.mt, {
  a: (a, b) => a + b, // add
  s: (a, b) => a - b, // substract
  m: (a, b) => a * b, // multiply
  d: (a, b) => a / b, // divide
  e: (a, b) => a % b, // rem mod
})

u.i = document.getElementById.bind(document)
u.id = document.getElementById.bind(document)
u.q = document.querySelectorAll.bind(document)
u.qi = document.querySelector.bind(document)
u.bd = document.body

Element.prototype.attr = Element.prototype.setAttribute

Event.prototype.i = function(){return this.target}

Element.prototype.on = Element.prototype.addEventListener

Element.prototype.i = function(k, v) {
  if (typeof k == 'object') {
    u.en(k).forEach(([k, v]) => u.va(v) && this.i(k, v))
    return this
  }

  if (k && u.va(v)) {
    // v === false ? this.removeAttribute(k) : this.setAttribute(k, v)
    if (v === -1) return this.getAttribute(k) ? this.removeAttribute(k) : this.setAttribute(k, 1), this
    if (v === false) return this.removeAttribute(k), this
    if (v === true) return this.setAttribute(k, 1), this

    if (v || v === 0) return this.setAttribute(k, v), this
    return this
  }
  // Array.from(this.attributes).forEach(attr => this.removeAttribute(attr.name))
  if (k) return this.getAttribute(k)
  // return Array.from(this.attributes).map(i => [i.name, i.value]).filter(i => !(['id', 'class', 'style'].includes(i[0]) && i[0].startsWith('data')))
  const im = Array.from(this.attributes).map(i => [i.name, i.value]).filter(i => !(['id', 'class', 'style'].includes(i[0]))).filter(i => !(i[0].startsWith('data')))
  return Object.fromEntries(im)
}

Element.prototype.e = function(v) {
  if (v === void 0) {
    if ('src' in this) { return this.src }
    if ('value' in this) { return this.value }
    if ('textContent' in this) { return this.textContent }
  }
  if (u(v) == 'array') {
    return v.t(i => this.i1(i).e())
  }
  if (typeof v == 'object') {
    u.en(v).forEach(([k, v]) => u.va(v) && this.i1(k).e(v))
    return this
  }

  if ('src' in this) {this.src = v; return this}
  if ('value' in this) {this.value = v; return this}
  if ('textContent' in this) {this.textContent = v; return this}
}

Element.prototype.s = function(k, v) {
  if (typeof k == 'string' && k.includes('{')) {
    const rid = u.mt().toString(36).t(2, 5)
    const kk = k.e('}', `} [${rid}] `)
    this.i(rid, '')
    this.h(3, `<style scoped>${kk}</style>`)
    return this
  }
  if (typeof k == 'string') {
    this.style.cssText += k
    return this
  }
  if (typeof k == 'object') {
    u.en(k).forEach(([k, v]) => this.s(k, v))
    return this
  }
  if (k && u.va(v)) {
    v === false ? this.style.removeProperty(k) : this.style.setProperty(k, v)
    return this
  }
  const c = getComputedStyle(this)
  if (k) return c.getPropertyValue(k)
  return c
}

Element.prototype.h = function(k, v) {
  if (k == '_o') {
    if (v) { this.outerHTML = v; return this }
    return this.outerHTML
  }
  if (k in [1, 2, 3, 4]) {
    const ps = ['beforebegin', 'afterbegin', 'beforeend', 'afterend']
    if (v) { this.insertAdjacentHTML(ps[k - 1], v); return this }
    return this
  }
  if (k == 'html' || k == '_h') {
    if (v) { this.innerHTML = v; return this }
    return this.innerHTML
  }
  if (k !== void 0) { this.innerHTML = k; return this }
  return this.innerHTML
}

Element.prototype.n = function(k, v) {
  if (k === void 0) { return this.parentNode }
  if (typeof k === 'number') { return this.children[k] }
  // if (k == '_p') { return this.parentNode }
  if (k == '_c') { return Array.from(this.children) }
  if (k == '_b') { return Array.from(this.parentNode.children) }
  if (k.startsWith('#') || k.startsWith('[')) return this.shadowRoot ? this.shadowRoot.querySelector(k) : this.querySelector(k)
  if (/^[a-z]\d+$/.test(k)) return this.shadowRoot ? this.shadowRoot.querySelector('#' + k) : this.querySelector('#' + k)
  const ql = this.shadowRoot ? this.shadowRoot.querySelectorAll(k) : this.querySelectorAll(k)
  return Array.from(ql)
}

u.path = location
u.disk = localStorage
u.db = {}

const env = {}
const ua = navigator.userAgent.toLowerCase()
const isWeixin = ua.indexOf('micromessenger') != -1
const agent = /(iPhone|iPad|iOS)/i.test(navigator.userAgent)
env.rt = isWeixin ? 'wx' : 'web'
env.os = agent ? 'i' : 'a'
u.env = env

const go = (href, body, config) => {
  if(href == -1){
    history.go(-1)
    return
  }
  const search = body ? '?' + u.net.qs(body) : ''
  const url = href + search
  if (href.startsWith('http') || href.startsWith('/')) {
    u.path.assign(url)
  }
}
u.go = go

const click = function(e) {
  if (e.target.dataset && e.target.dataset.href) {
    go(e.target.dataset.href)
  }
  const id = e.target.id.includes('_') ? e.target.id.split('_')[0] : e.target.id

  const rules = this.rules
  if (rules.href) {
    const href = rules.href[id]
    href && go(href)
  }

  if (rules.click) {
    const handler = rules.funs[rules.click[id]]
    handler && handler.bind(this)(e)
  }
}
u.click = click

function bind(fn, args) {
  return function(it) {
    return fn.bind(it)(args)
  }
}

function qs(i) {
  if (!i) return ''
  if (u(i) == 'string') return Object.fromEntries(i.split('&').map(it => it.split('=').map(decodeURIComponent)))
  return Object.entries(i).filter(i => u.va(i[1])).map(it => it.join('=')).join('&')
}

function sq(qs) {
  if (!qs) {return {}}
  return Object.fromEntries(qs.split('&').map(bind(''.split, '=')))
}

u.net = {}
u.net.sq = sq
u.net.qs = qs
u.qs = qs
u.sq = sq

function get(url, body, config){
  const search = body ? '?' + u.net.qs(body) : ''
  return Vue.axios.get(url + search, config).then(res => res.data)
}

function fet(url, body, config){
  return Vue.axios.post(url, qs(body), config).then(res => res.data)
}
u.net.get = get
u.net.fet = fet
u.get = get
u.fet = fet

import { qcs } from '@/pages/todo/dev/qcs.js'

// 插入shadowDom实现弹窗
const pop2 = (html, css, opt) => {
  const style = `
    .mask {
      position: fixed;
      top: 0; right: 0; bottom: 0; left: 0;
      background-color: rgba(0, 0, 0, .5);
    }
    ul, li {display: block;margin: auto;padding: 0;}div, ::before, ::after {background-repeat: no-repeat;background-size: 100%;background-position: center;}.i {display: inline-block;}.p {position: relative;}.a {position: absolute;}.d {display: block;}.f {display: flex;}.g {display: grid;}.t {text-align: center;}
      `
  const c = qcs(css).e(/\b(\d+(\.\d+)?)px\b/ig, (m, x) => x > 5 ? Number(x / (375 / 100)).toFixed(2) + 'vw' : x + 'px')

  const h = `<div class="mask"><style>${style}</style><style>${c}</style>${html}</div>`

  const hide = e => u.qi('.screen') && u.qi('.screen').remove()
  hide()

  const node = document.createElement('div')
  node.className = 'screen'
  const sr = node.attachShadow({ mode: 'open' })
  sr.innerHTML = h
  document.body.appendChild(node)

  if (opt && opt.init && typeof opt.init == 'function') {
    opt.init(node)
  }

  return { hide }
}

// 插入innerHTML实现弹窗, 自动添加类名前缀避免类名冲突
const pop3 = (content, type, opt) => {
  const style = `
    .screen {
      position: fixed;
      top: 0; right: 0; bottom: 0; left: 0;
      background-color: rgba(0, 0, 0, .5);
    }

    ul, li {display: block;margin: auto;padding: 0;}div, ::before, ::after {background-repeat: no-repeat;background-size: 100%;background-position: center;}.i {display: inline-block;}.p {position: relative;}.a {position: absolute;}.d {display: block;}.f {display: flex;}.g {display: grid;}.t {text-align: center;}
    .screen > .mask > * { margin-top: 30vh; }
  `

  const c = content.replace(/^\s*(\.\w+)/gmi, '.screen .mask $1')
  const html = `<div class="mask">
  <style>${style}</style>
  ${c}
  </div>`

  const hide = e => u.qi('.screen') && u.qi('.screen').remove()
  hide()

  const node = document.createElement('div')
  node.className = 'screen'
  node.innerHTML = html
  document.body.appendChild(node)

  if (opt && opt.init && typeof opt.init == 'function') {
    opt.init(node)
  }

  return { hide }
}

const pop = (content, type, opt) => {
  if (content.startsWith('<')) {
    const c = content.replace(/\b(\d+(\.\d+)?)px\b/ig, (m, x) => x / 37.5 + 'rem')
    if (HTMLElement.prototype.attachShadow) {
      return pop2(c, type, opt)
    } else {
      return pop3(c, type, opt)
    }
  }

  const style = `
  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    z-index: 101;
    background-color: rgba(0, 0, 0, 0.7);
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .mask .ad {
    max-width: 75%;
    position: relative;
  }

  .mask .ad .bg {
    width: 100%;
  }

  .mask .ad[type="ad"]::before {
    content: "广告";
    width: 29px;
    height: 16px;
    position: absolute;
    text-align: center;
    font-size: 10px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    color: #fff;
  }

  .mask .fun {
    margin-top: -25%;
    z-index: 1;
  }

  .fun[type="ad"], .fun[type="img"] {
    display: none;
  }

  .mask .fun .confirm {
    display: inline-block;
    width: 100%;
    padding-top: 15%;
    text-align: center;
  }

  .mask .fun .cancel {
    display: inline-block;
    width: 100%;
    padding-top: 15%;
    text-align: center;
  }

  .mask .fun[type="row"] .confirm {
    width: 50%;
  }

  .mask .fun[type="row"] .cancel {
    width: 45%;
  }

  .mask .close {
    width: 10%;
    height: 6%;
    margin-top: 4%;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'%3E%3Cpath d='M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z' fill='none' stroke='%23fff' stroke-miterlimit='10' stroke-width='20'/%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='20' d='M320 320L192 192M192 320l128-128'/%3E%3C/svg%3E");
  }`

  const html = `<div class="mask">
      <div class="ad">
        <img class="bg" referrerPolicy="no-referrer" referrer="no-referrer">
      <div class="fun">
        <div class="confirm"></div><div class="cancel"></div>
      </div>
      </div>
      <div class="close"></div>
      <style>${style}</style>
    </div>`

// 定义弹窗关闭函数
  const hide = e => u.qi('.screen') && u.qi('.screen').remove()
// 清除已有弹窗
  hide()
  const node = document.createElement('div')
  node.className = 'screen'
  node.innerHTML = html
  document.body.appendChild(node)

// 设置图片地址
  if (content) {
    u.qi('.mask .bg').attr('src', content)
  }
// 设置弹窗类型, 默认为img
  const t = type || 'img'
  u.qi('.mask .fun').attr('type', t)
  u.qi('.mask .ad').attr('type', t)
// 添加自定义样式
  if (opt && opt.style) {
    u.qi('.mask').insertAdjacentHTML(`beforeend`, `<style>${opt.style}</style>`)
  }

// 绑定链接跳转地址和点击函数
  if (opt && opt.href) {
    u.qi('.mask .bg').on('click', e => {u.go(opt.href);hide()})
  }
  if (opt && opt.click && typeof opt.click == "function") {
    u.qi('.mask .bg').on('click', e => {opt.click();hide()})
  }
// 绑定功能按钮和关闭按钮函数
  if (opt && opt.confirm && typeof opt.confirm === "function") {
    u.qi('.mask .fun .confirm').on('click', e => {opt.confirm();hide()})
  }
  if (opt && opt.cancel && typeof opt.cancel === "function") {
    u.qi('.mask .fun .cancel').on('click', e => {opt.cancel();hide()})
  }
  if (opt && opt.close && typeof opt.close === "function") {
    u.qi('.mask .close').on('click', opt.close)
  }
// 点击关闭按钮默认行为关闭弹窗
  u.qi('.mask .close').on('click', hide)
// 返回弹窗对象引用，可以在外部调用关闭函数
  return { hide }
}

var ui = {

}

/***
 * modal模态框  (opts 接收一个对象参数 )
 * 为简化使用, 传入一个参数时, 作为只有一个按键的弹窗, 类似alert,
 * 第二个参数传入true或非零数字, 作为有两个按键的弹窗, 类似confirm
 * @param title 标题
 * @param content 内容
 * @param cancelText 取消按钮的文字
 * @param confirmText 确认按钮的文字
 * @param skin 自定义class样式
 * @param showCancel 是否显示取消按钮，默认为 true
 * @param cancel {function} 取消按钮的回调函数
 * @param confirm {function}  确定按钮的回调函数
 * @param beforeHide {function}  退出模态框前的回调函数*/
ui.modal = function(content, confirm, opts) {
  var opts = opts || {}
  opts.title = opts.title || '提示';
  opts.content = content || opts.content || '内容';
  opts.cancelText = opts.cancelText || '取消';
  opts.confirmText = opts.confirmText || '确认';
  opts.skin = opts.skin || '';
  opts.showCancel = confirm || opts.showCancel || false;
  var modalEl = document.querySelector('#j_modal_wrap');
  if (modalEl) {
    modalEl.parentNode.removeChild(modalEl); //避免出现多个弹窗
  }

  var style = ui.css
  // log(style.replace(/\n/gm, '\\\n'))
  if(window.innerWidth != 750){ style = style.replace(/\b(\d+(\.\d+)?)px\b/ig, function(m, x){ return x / 2 + 'px' }) }
  var el = document.createElement('div');
  el.id = 'j_modal_wrap';
  el.className = 'ui_modal_wrap';
  el.innerHTML = '<div class="ui_modal ' + opts.skin + '" id="j_modal">' +
    '<div class="ui_modal_hd">' + opts.title + '</div>' +
    '<div class="ui_modal_bd">' + opts.content + '</div>' +
    '<div class="ui_modal_ft" id="js_btns2017">' +
    '<a href="javascript:;" class="ui_modal_btn ui_modal_default_btn" data-btn="_cancel2017">' + opts.cancelText + '</a>' +
    '<a href="javascript:;" class="ui_modal_btn ui_modal_primary_btn" data-btn="_confirm2017">' + opts.confirmText + '</a>' +
    '</div>' + '<style>' + style + '</style>' +
    '</div>';
  document.body.appendChild(el);
  var cancelBtn = document.querySelector('[data-btn="_cancel2017"]'),
    confirmBtn = document.querySelector('[data-btn="_confirm2017"]');
  !opts.showCancel && cancelBtn.parentNode.removeChild(cancelBtn);
  var modal_wrap = document.querySelector('#j_modal_wrap'),
    modal = document.querySelector('#j_modal');
  setTimeout(function() {
    modal.classList.add('ui_modal_in');
  }, 60)
  var hideModal = function() {
    modal.classList.remove('ui_modal_in');
    modal.classList.add('ui_modal_out');
    if (opts.beforeHide && typeof opts.beforeHide == 'function') {
      opts.beforeHide()
    }
    setTimeout(function() {
      modal_wrap.parentNode.removeChild(modal_wrap);
    }, 200)
  }

  var ModalbtnHandle = function(e) {
    var btn = e.target.dataset.btn;
    if (btn) {
      if (btn == "_cancel2017" && opts.cancel && typeof opts.cancel == "function") {
        setTimeout(function() {
          opts.cancel();
        }, 201)
      }
      if (btn == "_confirm2017" && opts.confirm && typeof opts.confirm == "function") {
        setTimeout(function() {
          opts.confirm();
        }, 201)
      }
      hideModal();
    };
  }
  cancelBtn && cancelBtn.addEventListener('click', function(e) {
    ModalbtnHandle(e);
  }, false);
  confirmBtn && confirmBtn.addEventListener('click', function(e) {
    ModalbtnHandle(e);
  }, false);
}

u.ui = ui
ui.pop = pop

u.ui.tip = VanToast
u.ui.ing = VanToast.loading
u.ui.suc = VanToast.success
u.ui.err = VanToast.fail
u.ui.clr = VanToast.clear

u.v = function (i = 'nv') {
  const t = ['nv', 'sv', 'gv'].indexOf(i)
  return t > -1 ? t : 0
}

u.nv = function(i) {
  return !u.vip(i)
}
